"use client";

import { useTheme } from "next-themes";
import Image from "next/image";
import { useState, useEffect } from "react";

export default function ThemeAwareLogo() {
  const { theme } = useTheme();
  const [isMounted, setIsMounted] = useState(false);

  // Usamos el logo blanco para modo oscuro y el negro para modo claro
  const logoSrc = theme === "dark" ? "/brand/solo_solar_logo_blanco.svg" : "/brand/solo_solar_logo_negro.svg";

  useEffect(() => {
    setIsMounted(true);
  }, []);

  // Mostrar un placeholder durante la hidratación para evitar el mismatch
  if (!isMounted) {
    return (
      <div className="h-8 w-24 bg-transparent" aria-label="Solosolar.es">
        {/* Placeholder con dimensiones definidas */}
      </div>
    );
  }

  return (
    <Image
      src={logoSrc}
      alt="Solosolar.es"
      width={120}  // Ajusta el tamaño según sea necesario
      height={32}  // Ajusta el tamaño según sea necesario
      className="h-8 w-auto object-contain"
      style={{ width: "auto", height: "2rem" }}
      priority={false}
    />
  );
}
